import { ShareWishlist } from './share-wishlist';

export interface ShareWishlistUpdate {
  [key: string]: ShareWishlist;
}
